import { render, staticRenderFns } from "./baleBaseInfo.vue?vue&type=template&id=aa4cb83a"
import script from "./baleBaseInfo.vue?vue&type=script&lang=js"
export * from "./baleBaseInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports